import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ApiConsumer } from '../../service/api-consumer';

/**
 * Redux slice for managing game-related filter data (`gamesFilter`).
 *
 * This slice handles:
 * - Fetching filter data for games via `fetchGamesFilter` async thunk
 * - Storing the list of items
 * - Managing loading and error states
 *
 * State shape:
 * {
 *   Items: Array<any>, // List of games or filter items
 *   loading: boolean,  // Indicates if the fetch is in progress
 *   error: null | unknown         // Contains error info if fetch fails
 * }
 */

export const fetchGamesFilter = createAsyncThunk('gamesFilter/fetchGamesFilter', async (payload: {}) => {
  const response = await ApiConsumer.getGamesFilter(payload);
  return response;
});

interface GamesFilterState {
  Items: { Text: string; Value: string }[];
  loading: boolean;
  error: null | unknown;
}

const initialState: GamesFilterState = {
  loading: false,
  error: null,
  Items: [{ Text: '', Value: '' }],
};

const gamesFilterSlice = createSlice({
  name: 'gamesFilter',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchGamesFilter.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchGamesFilter.fulfilled, (state, action) => {
        state.loading = false;
        state.Items = action.payload.Items;
      })
      .addCase(fetchGamesFilter.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
  },
});

export default gamesFilterSlice.reducer;
